module.exports = __webpack_public_path__ + "img/sidebar_background.ac552980.jpg";